import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from './userContext';
import { jwtDecode } from 'jwt-decode';

// Wir importieren usePermissions, um hasFeature abzufragen.
import { usePermissions } from './permissionContext';

function PrivateRoute({ children, adminOnly, requiredFeature, ...rest }) {
    const { user, logout } = useUser();
    const { hasFeature, isLoading } = usePermissions();
    const token = localStorage.getItem('token');

    let isTokenExpired = true;
    if (token) {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp > currentTime) {
            isTokenExpired = false;
        }
    }

    useEffect(() => {
        if (!user || isTokenExpired) {
            logout();
        }
    }, [user, isTokenExpired, logout]);

    // Wenn User nicht eingeloggt oder Token abgelaufen, leiten wir auf /login um
    if (!user || isTokenExpired) {
        return <Navigate to="/login" replace />;
    }
    if ((adminOnly || requiredFeature) && isLoading) {
        return null; // oder ein Lade-Skeleton
    }

    // Rolle des Users (z.B. admin, superadmin, user etc.)
    const { role } = user;

    /*
     * ODER-Logik für adminOnly + requiredFeature
     * ----------------------------------------------
     * Falls adminOnly=true, darf der User rein, wenn er admin oder superadmin ist
     * ODER er besitzt das angeforderte Feature (falls requiredFeature gesetzt ist).
     * 
     * Reihenfolge:
     * 1) Prüfen wir, ob adminOnly oder requiredFeature gesetzt ist.
     * 2) Falls beides definiert ist, reicht EINES von beiden aus (ODER).
     *    - Admin-Rechte => rein
     *    - Feature => rein
     * 3) Hat der User keins von beiden => Redirect zu /dashboard
     */
    if (adminOnly || requiredFeature) {
        // Prüfe, ob User Admin ist
        const userIsAdmin = (role === 'admin' || role === 'superadmin');
        // Prüfe, ob User das Feature hat
        const userHasFeature = requiredFeature ? hasFeature(requiredFeature) : false;

        // Falls adminOnly und requiredFeature existieren, checken wir das ODER
        // => Der User darf rein, wenn er Admin ist ODER das Feature hat
        if (!userIsAdmin && !userHasFeature) {
            return <Navigate to="/dashboard" replace />;
        }
    }

    // Wenn alle Checks erfüllt sind, rendern wir den Child-Content
    return children;
}

export { PrivateRoute };